import {useQuery} from 'react-query';
import {
  getAccountNumbers,
  IGetAccountNumbersResponse,
} from './getAccountNumbers';

const useGetAccountNumbers = (
  onSuccess?: (data: IGetAccountNumbersResponse) => void,
) => {
  const {data, isLoading, refetch} = useQuery<IGetAccountNumbersResponse>(
    ['get-user-account_numbers'],
    getAccountNumbers,
    {
      onSuccess: data => {
        onSuccess?.(data);
      },
    },
  );

  return {data, isLoading, refetch};
};

export default useGetAccountNumbers;
